import { ContentHeader, LayoutWithNavigationBreadcrumbs } from 'components';
import { isFinanceProject } from 'config';
import { type FormSubmit } from 'libs/form';
import { useTranslation } from 'libs/i18n';
import { RoutesId } from 'libs/navigation';
import { Stack } from 'libs/ui';

import { FormContent, FormFooter } from '../components';
import {
  type CreateLegalClientFormType,
  type FormErrors,
  Form,
  getSchema,
} from '../forms';

interface Props {
  formError: FormErrors | undefined;
  submitLoading: boolean;
  onSubmit: FormSubmit<CreateLegalClientFormType>;
}

export const CreateLegalClientView = ({
  formError,
  submitLoading,
  onSubmit,
}: Props) => {
  const { t } = useTranslation();

  return (
    <LayoutWithNavigationBreadcrumbs
      titles={{
        [RoutesId.personClients]: t('client.clients.personal.title'),
        [RoutesId.createLegalClient]: t('client.createLegalClient.title'),
      }}
    >
      <Stack spacing={24}>
        <Form
          initialErrors={formError}
          validationSchema={getSchema(t, {
            enabledCivilLawSubject: isFinanceProject(),
          })}
          onSubmit={onSubmit}
        >
          <ContentHeader header={t('client.createLegalClient.title')} />
          <FormContent />
          <FormFooter submitLoading={submitLoading} />
        </Form>
      </Stack>
    </LayoutWithNavigationBreadcrumbs>
  );
};
